module.exports = "<h1>{{ 'Forbidden!' | translate }}</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/pages/forbidden.html
// module id = 1086
// module chunks = 0